import React from 'react';
import {connect} from 'react-redux';
import {FacebookShareButton, FacebookIcon} from 'react-share';
import {eventByType} from '../../../../../../api/eventsApi';
import tagular from '../../../../../../util/tagular';

const PrimaryScoreCardContent = ({result, assessment, heading, inlineParentMetadata}) => {
    let image;
    let description;

    const shareURL = `${window.location.origin}/assessment/assessment/${
        assessment.name
    }/prompt/1?v=${assessment.version}&share_filters=${encodeURIComponent(result.filters[0])}`;

    const handleShareClick = e => {
        eventByType('social-share', assessment.id, {
            eventAction: `ShareClicked_Quizzler_${assessment.eventConfig.assessmentName}_${assessment.eventConfig.assessmentVersion}`,
            eventLabel: 'facebook',
            inlineParentMetadata
        });

        tagular.sendElementClickedEvent(e, {
            lcoation: 'CARDS',
            position: 'Quizzler Result Page',
            elementType: 'BUTTON',
            name: `Quizzler_${assessment.eventConfig.assessmentName}_${assessment.eventConfig.assessmentVersion}`,
            action: 'EXTERNALLINK',
            htmlID: 'ip0'
        });
    };

    if (result.imageUrl && result.imageUrl !== '') {
        image = (
            <div className="img-container">
                <img className="result-img" src={result.imageUrl} alt="" />
            </div>
        );
    }

    if (result.primaryDescription && result.primaryDescription !== '') {
        description = (
            <div
                className="description"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{__html: result.primaryDescription}}
            />
        );
    }

    const share = (
        <div className="social-share">
            <div className="share-label">
                <strong>Share on:</strong>
            </div>
            <div className="share-button">
                <FacebookShareButton url={shareURL}>
                    <FacebookIcon size="25" round onClick={handleShareClick} />
                </FacebookShareButton>
            </div>
        </div>
    );

    return (
        <>
            {heading && <h3 className="result-card-heading primary">{heading}</h3>}
            <div className="result-card primary">
                {image}
                <div className="result-card-content">
                    <h1 className="title">{result.title}</h1>

                    {description}
                    {share}
                </div>
            </div>
        </>
    );
};

const mapStateToProps = state => {
    return {
        inlineParentMetadata: state.inline.parentMetadata
    };
};

export default connect(mapStateToProps)(PrimaryScoreCardContent);
